var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alerts.length !== 0)?_c('v-row',{staticClass:"mt-0 mb-2",attrs:{"justify":"center"}},[_c('v-col',{staticClass:"py-0 mb-n4",attrs:{"cols":"12","md":"10","lg":"9"}},_vm._l((_vm.alerts),function(alert){return _c('AlertBox',{key:alert.Id,attrs:{"title":alert.Name,"content":alert.Notice__c,"link":alert.URL__c}})}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }